import { Injectable } from '@angular/core';
import { System } from '../../shared-components/System';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ScheduleHistoryModel, ScheduleHistorySearchModel } from './schedule-history.model';
import { formatDate } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class ScheduleHistoryService {

  constructor(
    private http: HttpClient
  ) { }

  getCourseChangeHistory(siteId: number, yearId: number, scheduleHistorySearchModel: ScheduleHistorySearchModel): Observable<ScheduleHistoryModel[]> {
    let queryString = '';
    queryString += '?siteId=' + siteId +
      '&yearId=' + yearId +
      '&addFromDate=' + scheduleHistorySearchModel.classEntryDateFrom +
      '&addToDate=' + scheduleHistorySearchModel.classEntryDateTo +
      '&dropFromDate=' + scheduleHistorySearchModel.classExitDateFrom +
      '&dropToDate=' + scheduleHistorySearchModel.classExitDateTo +
      '&lastName=' + scheduleHistorySearchModel.lastName +
      '&firstName=' + scheduleHistorySearchModel.firstName +
      '&studentNumber=' + scheduleHistorySearchModel.studentNumber +
      '&studentListId=' + scheduleHistorySearchModel.studentListId +
      '&studentTeamId=' + scheduleHistorySearchModel.studentTeamId +
      '&counselorId=' + scheduleHistorySearchModel.counselorId ;
    return this.http.get<ScheduleHistoryModel[]>(System.apiURL.Student + 'GetCourseChangeHistory' + queryString);
  }
}
